module.exports = __webpack_public_path__ + "static/media/Thames.022f03f6.png";